export default __webpack_public_path__ + "static/media/transfer-send-step3.d8c80f2a.png";